// MARK: - Seeded PRNG (mulberry32)

/** Hash a string to a 32-bit unsigned integer using FNV-1a (32-bit). */
function hashString(str: string): number {
  let hash = 0x811c9dc5; // FNV offset basis
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193); // FNV prime
    hash >>>= 0; // keep unsigned 32-bit
  }
  return hash >>> 0;
}

/**
 * Create a seeded pseudo-random number generator using mulberry32.
 * Returns a closure that yields a float in [0, 1) on each call.
 * Deterministic: the same seed always produces the same sequence.
 */
export function makeRng(seed: string | number): () => number {
  let s = typeof seed === 'string' ? hashString(seed) : seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) >>> 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) >>> 0;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Return a random index in [0, n) using the given rng. */
export function pickIndex(rng: () => number, n: number): number {
  return Math.floor(rng() * n);
}

/** Return a random element from an array using the given rng. */
export function pick<T>(rng: () => number, arr: T[]): T {
  return arr[pickIndex(rng, arr.length)];
}
